/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import type { JSX } from 'react'
import type { Mesh, MeshStandardMaterial } from 'three'
import type { GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      Cube007_Cube008: Mesh
      Cube006_Cube007: Mesh
      Cylinder012: Mesh
      Cylinder011: Mesh
      Plane001_Plane002: Mesh
    }
    materials: {
      GrayPlastic: MeshStandardMaterial
      BlackCoatSteel: MeshStandardMaterial
      WhiteSteelScrew: MeshStandardMaterial
      BlackPlastic: MeshStandardMaterial
      BlackWood: MeshStandardMaterial
    }
  }

export function Desk(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('/models/desk.glb') as GLTFResult
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube007_Cube008.geometry}
        material={materials.GrayPlastic}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube006_Cube007.geometry}
        material={materials.BlackCoatSteel}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder012.geometry}
        material={materials.WhiteSteelScrew}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder011.geometry}
        material={materials.BlackPlastic}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Plane001_Plane002.geometry}
        material={materials.BlackWood}
        material-color="#C4A484"
      />
    </group>
  )
}

useGLTF.preload('/models/desk.glb')
